import { apiClient } from '@/sdk/shared/apiClient';
import type { UserAccessResponse } from './userAccessTypes';

export const userAccessApi = {
  getUserAccess: async (tenantId: string, userId: string): Promise<UserAccessResponse> => {
    return apiClient.get<UserAccessResponse>(`/tenants/${tenantId}/users/${userId}/access`);
  },
};
